import { lazily } from 'react-lazily'

import { wrapSuspense } from '../../atoms/placeholders/Suspense'

const { EllipsedLabel: RawEllipsedLabel } = lazily(() => import('./EllipsedLabel'))
const EllipsedLabel = wrapSuspense<typeof RawEllipsedLabel>(RawEllipsedLabel)
export { EllipsedLabel }
